import { combineAndDedupArrays, updateObject } from 'shared/utility';
import * as actionTypes from 'store/actions/actionTypes';

const initialState = {
  loading: false,
  error: false,
  recentPlaces: [],
  userAllRecentActivity: [],
  hasMoreUserAllRecentActivity: true,
  userMyRecentActivity: [],
  hasMoreUserMyRecentActivity: true,
};

const fetchRecentPlacesStart = (state) => {
  return updateObject(state, {
    loading: true,
    error: null,
    recentPlaces: [],
  });
};

const fetchRecentPlacesSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: null,
    recentPlaces: action.recentPlaces,
  });
};

const fetchRecentPlacesFailed = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const fetchUserRecentActivityStart = (state, action) => {
  const recentActivityKey = action.Show === 'mine' ? 'userMyRecentActivity' : 'userAllRecentActivity';
  const recentActivityMoreKey = action.Show === 'mine' ? 'hasMoreUserMyRecentActivity' : 'hasMoreUserAllRecentActivity';
  let updatedState = updateObject(state, {
    error: null,
    loading: true,
  });
  if (action.Page === 1) {
    updatedState = updateObject(state, {
      [recentActivityKey]: [],
      loading: true,
      error: null,
      [recentActivityMoreKey]: true,
    });
  }
  return updatedState;
};

const fetchUserRecentActivitySuccess = (state, action) => {
  const recentActivityKey = action.Showing === 'mine' ? 'userMyRecentActivity' : 'userAllRecentActivity';
  const recentActivityMoreKey = action.Showing === 'mine' ? 'hasMoreUserMyRecentActivity' : 'hasMoreUserAllRecentActivity';
  const returnedUserActivity = action.UserRecentActivity ? action.UserRecentActivity : [];
  const userActivityArray = combineAndDedupArrays([...state[recentActivityKey]], returnedUserActivity);
  return updateObject(state, {
    loading: false,
    error: null,
    [recentActivityKey]: userActivityArray,
    [recentActivityMoreKey]: !!(action.UserRecentActivity && action.UserRecentActivity.length > 0),
  });
};

const fetchUserRecentActivityFailed = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const clearActivity = (state) => {
  return updateObject(state, {
    loading: false,
    error: false,
    recentPlaces: [],
    userAllRecentActivity: [],
    hasMoreUserAllRecentActivity: true,
    userMyRecentActivity: [],
    hasMoreUserMyRecentActivity: true,
  });
};

const logoutSuccess = (state) => {
  return updateObject(state, {
    ...initialState,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_RECENT_PLACES_START:
      return fetchRecentPlacesStart(state, action);
    case actionTypes.FETCH_RECENT_PLACES_SUCCESS:
      return fetchRecentPlacesSuccess(state, action);
    case actionTypes.FETCH_RECENT_PLACES_FAILED:
      return fetchRecentPlacesFailed(state, action);
    case actionTypes.FETCH_USER_RECENT_ACTIVITY_START:
      return fetchUserRecentActivityStart(state, action);
    case actionTypes.FETCH_USER_RECENT_ACTIVITY_SUCCESS:
      return fetchUserRecentActivitySuccess(state, action);
    case actionTypes.FETCH_USER_RECENT_ACTIVITY_FAILED:
      return fetchUserRecentActivityFailed(state, action);
    case actionTypes.UPDATE_POSTING_AS:
      return clearActivity(state, action);
    case actionTypes.REVERT_TO_SIGNED_IN_AS:
      return clearActivity(state, action);
    case actionTypes.LOGOUT_SUCCESS:
      return logoutSuccess(state, action);
    default:
      return state;
  }
};
export default reducer;
